<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <div class="dash-trucks-top1" *ngIf="deleteAction">
    <span>Selected: {{ SelectedNumber }}</span>
  </div>
  <div class="trip-acoordion">
    <div class="dash-trucks-top2">
      <div class="refresh_icon">
        <img
          src="../../../assets/img/refresh_icon.png"
          (click)="refresh()"
          alt=""
        />
      </div>
      <button
        type="button"
        class="button buttonBlue mr-2 fixed-btn"
        (click)="autoGeneratedDevice()"
      >
        Auto Generated Devices
      </button>
      <button
        *ngIf="addBtn"
        type="button"
        class="button buttonBlue fixed-btn"
        (click)="GoToAddGps('New', null)"
      >
        <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
        Add
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="selectGps"
        (click)="onSelect()"
      >
        <img
          class="trucks-head-img"
          src="../../../assets/img/check-circle.svg"
        />
        Select
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="cancelGps"
        (click)="onSelectCancel()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="deleteGps"
        (click)="onDelete()"
      >
        <img class="trucks-head-img" src="../../../assets/img/delete.svg" />
        Delete
      </button>
      <button
        uppercase
        type="button"
        *ngIf="searchButton"
        class="button search-btn fixed-btn"
        (click)="openSearch()"
      >
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input
          class="search pl-2"
          placeholder="Search by GPS"
          id="gpsName"
          #newItem
          (keyup)="onInputChange(newItem.value)"
        />
        <img
          class="search_number"
          *ngIf="search_btn"
          (click)="search(newItem.value)"
          src="../../../assets/img/search-white.svg"
        />
        <button
          *ngIf="clear_Btn"
          type="button"
          class="search_number1"
          (click)="resetSearch()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            class="search_icon"
          >
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="trucks">
      <div [class.spinner]="loading"></div>

      <div class="row to_container" *ngIf="!GpsList?.length && !loading">
        <h4 class="error_msg">No Records Found.</h4>
      </div>
      <div class="row">
        <div class="col-md-3 mb-3" *ngFor="let item of GpsList; let i = index">
          <div class="truckscol">
            <mat-checkbox
              *ngIf="checkBox"
              (change)="matItem($event, item._id, i)"
            ></mat-checkbox>
            <a class="editimg" (click)="addNotes(item._id)">Add Notes</a>
            <p class="truck-number" (click)="GoToAddGps('Edit', item)">
              {{ item.device_reference_no }}
            </p>
            <p class="truck-date">
              {{ item.updatedAt | date : "dd-MM-yyyy" }}
            </p>
            <p class="truck-date">
              {{ item.vehicle_info?.lastStatusTime | date : "HH:mm:ss" }}
            </p>

            <p class="truck-insu">({{ item.vehicle_info?.vehicleNumber }})</p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="last_page && last_page > 1" class="pagination">
      <button
        class="btn"
        [disabled]="fetch_page == 1"
        (click)="pagination('-1')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button
        class="btn"
        [disabled]="fetch_page == 1"
        (click)="pagination('first')"
      >
        <img
          src="../../../assets/img/pagination-left.svg"
          alt=""
          class="btn--icon"
        />
      </button>
      <div class="pages">
        <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
      </div>
      <button
        class="btn"
        [disabled]="last_page == fetch_page"
        (click)="pagination('last')"
      >
        <img
          src="../../../assets/img/pagination-right.svg"
          alt=""
          class="btn--icon"
        />
      </button>
      <button
        class="btn"
        [disabled]="last_page == fetch_page"
        (click)="pagination('1')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap=" round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
